export const environment = {
  production: true,
  appVersion: '2.4.2', //Production
  apiUrl: '/backend/api/v1/',
  masterapiurl: '/masterend/api/v1/'
};
